<div class="chat-wrapper">
  <div class="chat-header">
    <h2>Suggest new delivery time</h2>
    <button class="close-button" (click)="handleClose()">
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="26" height="26" rx="13" fill="#E9E9ED" />
        <path
          d="M17.5 8.5L8.5 17.5M8.5 8.5L17.5 17.5"
          stroke="#343E57"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
  </div>
  <div class="chat-container">
    <div class="messages" #messagesContainer>
      <div *ngFor="let message of messages" [class]="'message ' + message.type" [class.selected]="message.isSelected">
        <div class="message-content" *ngIf="message.content">
          <p>{{ message.content }}</p>
        </div>
        <div
          *ngIf="
            message.type === 'bot' &&
            showLoadingIndicator &&
            message === messages[messages.length - 1] &&
            deliveryOptions.length === 0
          "
          class="message-content typing-indicator">
          <div class="typing-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="cta-options" *ngIf="message.isCTA && message.ctaOptions">
          <button
            *ngFor="let option of message.ctaOptions"
            [class]="'cta-button ' + option.type"
            (click)="option.action()">
            {{ option.text }}
          </button>
          <button
            *ngIf="!showMoreOptions && message.type === 'bot' && message.content.includes('suggested delivery slots')"
            class="cta-button secondary"
            (click)="toggleMoreOptions()"
            [disabled]="isLoading">
            View more options
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
